export interface CustomerUserActionTypes {
    type: CustomerUserActions;
    payload?: any;
}

export enum CustomerUserActions {
  CREATE_CUSTOMER_USER = "CREATE_CUSTOMER_USER",
  GET_CUSTOMER_USER_LIST = "GET_CUSTOMER_USER_LIST",
  SET_CUSTOMER_USER_LIST = "SET_CUSTOMER_USER_LIST",
  SET_CUSTOMER_USER_LIST_PAGE_COUNT = "SET_CUSTOMER_USER_LIST_PAGE_COUNT",
  GET_CUSTOMER_USER_DATA_BY_ID = "GET_CUSTOMER_USER_DATA_BY_ID",
  SET_CUSTOMER_USER_DATA_BY_ID = "SET_CUSTOMER_USER_DATA_BY_ID",
  EDIT_CUSTOMER_USER_DATA_BY_ID = "EDIT_CUSTOMER_USER_DATA_BY_ID",
  SET_CUSTOMER_USER = "SET_CUSTOMER_USER",
  EDIT_CUSTOMER_USER_DETAILS="EDIT_CUSTOMER_USER_DETAILS",
  SET_LOGGEDIN_CUSTOMER_USER_DATA = "SET_LOGGEDIN_CUSTOMER_USER_DATA",
  CHANGE_CUSTOMER_USER_PASSWORD = "CHANGE_CUSTOMER_USER_PASSWORD",
}